var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-title',{attrs:{"color":"grape"}},[_vm._v("Reporting")]),(_vm.reportsLoading)?_c('async-loader'):[_c('report-type',{attrs:{"report-type":_vm.reportType}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }